export const SEARCH_FIELDS = {
  DIMENSION: 'DIMENSION',
  EAN: 'EAN',
  CAI: 'CAI',
  REFERENCE: 'REFERENCE',
} as const;
